import { NotificacoesApi } from "../../hooks/notificacoesApi";
import { HeaderContext } from "./HeaderContext";
import { useContext, useEffect, useState } from "react";
import { TokensContext } from "../Tokens/TokensContext";

export const HeaderProvider = ({ children }: { children: JSX.Element }) => {
  const notificacoesApi = NotificacoesApi();
  const { tokensDisponiveis } = useContext(TokensContext);
  
  const [modalTokensIa, setModalTokensIa] = useState(false);
  const [temNotificacaoNova, setTemNotificacaoNova] = useState(false);
  const [temAulaNova, setTemAulaNova] = useState(false);

  useEffect(() => {
    let isCancelled = false;
    
    const init = async () => {
      try {
        const res = await notificacoesApi.temNotificacaoNova();
        if (!isCancelled) {
          setTemAulaNova(res.tem_aula_nova || false);
          setTemNotificacaoNova(res.tem_notificacao_nova || false);
        }
      } catch (error) {
        console.error("Erro ao buscar notificações:", error);
      }
    };
    
    init();
    
    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <HeaderContext.Provider value={{ 
      modalTokensIa, 
      setModalTokensIa, 
      temNotificacaoNova, 
      setTemNotificacaoNova, 
      temAulaNova, 
      setTemAulaNova,
      tokensDisponiveis,
      setTokensDisponiveis: () => {}
    }}>
      {children}
    </HeaderContext.Provider>
  );
};
